/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type PublishsetTagsDestroyRequest = {} | null | undefined;
export type PublishsetTagsDestroyResponse = any;

export type PublishsetTagsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this publishset tag.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/publishset_tags/{id}/
 *
 * ```yaml
 * operationId: publishset_tags_destroy
 * tags:
 *   - publishset_tags
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const publishsetTagsDestroyOperation = ({ id, ...rest }: PublishsetTagsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/publishset_tags/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/publishset_tags/{id}/' };
  };

/**
 * DELETE /dmx-server/publishset_tags/{id}/
 *
 * ```yaml
 * operationId: publishset_tags_destroy
 * tags:
 *   - publishset_tags
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const publishsetTagsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: PublishsetTagsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = publishsetTagsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
